/* Quantity / purchase choice in the buy box (markup: snippets/ar-buy-price.liquid, snippets/ar-pdp-sets.liquid).
   - 30 ml products: 1 / 3 / 5 bottles (buy 2 get 1 free, buy 3 get 2 free). Switching updates the total, the struck-through price and the line under it.
   - Emulsion / Cleanser: single product or a set. Picking a set swaps the form's variant id (one Add to cart button) and shows a "View set details" link.
   - New-member row (snippets/ar-starter-cta, Veil): while it is picked, Add to cart reads "Join free" / "Checkout" and goes to its link; Buy now steps aside.
   The mobile sticky bar follows the choice (assets/ar-sticky-atc.js listens to the same change event). */
if (!customElements.get('ar-buy-qty')) {
  customElements.define('ar-buy-qty', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.addLabel = this.form?.querySelector('[name="add"] span:not(.sold-out-message)');
      this.addText = this.addLabel?.textContent;
      this.goTo = null;
      this.intercept = (e) => {
        if (!this.goTo || (e.type === 'click' && !e.target.closest?.('[name="add"]'))) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        location.href = this.goTo;
      };
      this.form?.addEventListener('click', this.intercept, true);
      this.form?.addEventListener('submit', this.intercept, true);
      this.sync = () => {
        const setChoice = this.hasAttribute('data-ar-set-choice');
        const picked = this.querySelector(setChoice ? 'input[name="ar_purchase"]:checked' : 'input[name="quantity"]:checked');
        if (!picked) return;
        const total = this.querySelector('[data-ar-total]');
        const was = this.querySelector('[data-ar-was]');
        const note = this.querySelector('[data-ar-note]');
        if (total) total.textContent = picked.dataset.total || '';
        if (was) {
          was.textContent = picked.dataset.was || '';
          was.hidden = !picked.dataset.was;
        }
        if (note) note.textContent = picked.dataset.note || '';
        this.goTo = picked.dataset.arGo || null;
        if (this.addLabel && (this.goTo || this.addText)) this.addLabel.textContent = this.goTo ? picked.dataset.arGoLabel : this.addText;
        const buyNow = this.form?.querySelector('[data-ar-buy-now]');
        if (buyNow) buyNow.style.display = this.goTo ? 'none' : '';
        if (setChoice) {
          const form = this.closest('form');
          const variant = form?.querySelector('input[name="id"]');
          if (variant) variant.value = picked.value;
          const details = this.querySelector('[data-ar-set-details]');
          if (details) {
            details.hidden = !picked.dataset.url;
            if (picked.dataset.url) details.href = picked.dataset.url;
            else details.removeAttribute('href');
          }
          form?.closest('product-form')?.handleErrorMessage?.();
        }
      };
      this.addEventListener('change', this.sync);
      this.querySelector('.ar-purchase-options')?.removeAttribute('hidden');
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.sync);
      this.form?.removeEventListener('click', this.intercept, true);
      this.form?.removeEventListener('submit', this.intercept, true);
    }
  });
}
